export default {
  // Seitentitel
  pageTitle: 'Veranstaltungseinstellungen | WedBox',
  settingsTitle: 'Veranstaltungseinstellungen',
  settingsDescription: 'Verwalten Sie Ihre Veranstaltungsdetails',
  
  // Vorhandene Basisfelder
  title: "Meine Veranstaltungen",
  myEvents: "Meine Veranstaltungen",
  description: "Erstellen und verwalten Sie Ihre Veranstaltungen",
  createEvent: "Veranstaltung erstellen",
  createNew: "Neu erstellen",
  currentEvent: "Aktuelle Veranstaltung",
  noEvents: "Keine Veranstaltungen",
  addFirstEvent: "Erstellen Sie Ihre erste Veranstaltung",
  createFirstEvent: "Erstellen Sie Ihre erste Veranstaltung",
  eventCreated: "Veranstaltung erfolgreich erstellt",
  eventUpdated: "Veranstaltung aktualisiert",
  eventDeleted: "Veranstaltung gelöscht",
  selectEventType: "Veranstaltungstyp auswählen",
  date: "Datum",
  location: "Ort",
  guestCount: "Gästezahl",
  budget: "Budget",
  status: "Status",
  active: "Aktiv",
  draft: "Entwurf",
  completed: "Abgeschlossen",
  cancelled: "Storniert",
  editEvent: "Veranstaltung bearbeiten",
  deleteEvent: "Veranstaltung löschen",
  confirmDelete: "Sind Sie sicher, dass Sie diese Veranstaltung löschen möchten?",
  yes: "Ja",
  no: "Nein",
  save: "Speichern",
  cancel: "Abbrechen",
  close: "Schließen",
  switch: "Wechseln",
  switchEvent: "Veranstaltung wechseln",
  switchedTo: "Gewechselt zu",
  currentlyActive: "Derzeit aktiv",
  searchEvents: "Veranstaltungen suchen",
  noEventsFound: "Keine Veranstaltungen gefunden",
  manage: "Verwalten",
  yourEvents: "Ihre Veranstaltungen",
  advancedView: "Erweiterte Ansicht",
  basicView: "Basisansicht",

  // Massenaktionen
  bulkActions: {
    title: "Massenaktionen",
    selectAll: "Alle auswählen",
    selected: "ausgewählt",
    delete: "Löschen",
    archive: "Archivieren",
    export: "Exportieren",
    duplicate: "Duplizieren",
    processing: "Verarbeitung...",
    confirmDelete: "Sind Sie sicher, dass Sie die ausgewählten Veranstaltungen löschen möchten?",
    description: "Verwalten Sie mehrere Veranstaltungen gleichzeitig"
  },

  // Abonnement-Info
  subscriptionInfo: {
    free: {
      title: "Kostenloser Plan",
      description: "Ideal für den Einstieg"
    },
    essential: {
      title: "Essential Plan",
      description: "Für kleine Veranstaltungen"
    },
    pro: {
      title: "Pro Plan",
      description: "Für große Veranstaltungen"
    }
  },

  dashboard: {
    subtitle: "Übersicht",
    title: "Veranstaltungs-Dashboard",
    usage: "Nutzung",
    gridView: "Rasteransicht",
    listView: "Listenansicht"
  },

  maxEventsReached: "Maximale Anzahl an Veranstaltungen erreicht",
  upgradeToCreateMoreEvents: "Upgrade durchführen, um mehr Veranstaltungen zu erstellen",

  // Veranstaltungstypen
  eventTypes: {
    wedding: "Hochzeit",
    engagement: "Verlobung",
    birthday: "Geburtstag",
    babyShower: "Babyparty",
    baptism: "Taufe",
    reunion: "Klassentreffen",
    corporate: "Firmenveranstaltung",
    other: "Sonstiges",
    WEDDING: "Hochzeit",
    PACS: "Eingetragene Partnerschaft",
    pacs: "Eingetragene Partnerschaft",
    ANNIVERSARY: "Jubiläum",
    anniversary: "Jubiläum",
    CORPORATE: "Firmenveranstaltung",
    OTHER: "Sonstiges",
    BABYSHOWER: "Babyparty",
    BAPTISM: "Taufe"
  },

  // Formularabschnitte
  form: {
    eventDetails: "Veranstaltungsdetails",
    basicInfo: "Basisinformationen",
    eventName: "Veranstaltungsname",
    eventType: "Veranstaltungstyp",
    eventDate: "Veranstaltungsdatum",
    eventLocation: "Veranstaltungsort",
    partners: "Partner / Hauptpersonen",
    partner1: "Partner 1 / Hauptperson", 
    partner2: "Partner 2 (optional)",
    firstName: "Vorname",
    lastName: "Nachname",
    placeholders: {
      eventName: 'Bsp: Hochzeit von Maria und Peter',
      eventLocation: 'Bsp: Schloss Versailles, Paris',
      firstName: 'Vorname',
      lastName: 'Nachname',
    },
  },

  // Aktionen
  actions: {
    create: "Erstellen",
    edit: "Bearbeiten",
    delete: "Löschen",
    duplicate: "Duplizieren",
    share: "Teilen",
    setDefault: "Als Standard festlegen",
    selectEvent: "Veranstaltung auswählen",
  },

  // Datumsformatierung
  dateFormat: {
    notSpecified: 'Nicht angegeben',
    invalid: 'Ungültiges Datum',
  },

  // Kartendetails
  details: {
    title: 'Veranstaltungsdetails',
    id: 'ID:',
    eventCount: '{{count}} Veranstaltungen insgesamt',
    singleEvent: '1 Veranstaltung',
  },

  // Leerer Zustand
  empty: {
    noEventSelected: 'Keine Veranstaltung ausgewählt',
    selectEventDescription: 'Bitte wählen Sie eine Veranstaltung aus, um auf deren Einstellungen zuzugreifen.',
  },

  // Erfolgsmeldungen
  success: {
    title: 'Erfolg',
    eventUpdated: 'Veranstaltung erfolgreich aktualisiert',
  },

  // Fehlermeldungen
  errors: {
    title: 'Fehler',
    updateFailed: 'Aktualisierung der Veranstaltung fehlgeschlagen',
    updateError: 'Fehler beim Aktualisieren der Veranstaltung',
    deleteFailed: 'Löschen der Veranstaltung fehlgeschlagen',
    deleteError: 'Fehler beim Löschen der Veranstaltung',
  },

  // Löschbestätigung
  deleteConfirmation: {
    title: 'Veranstaltung löschen',
    description: 'Sind Sie sicher, dass Sie die Veranstaltung "{{eventName}}" löschen möchten? Diese Aktion ist irreversibel und alle zugehörigen Daten werden gelöscht.',
    confirm: 'Löschen',
    cancel: 'Abbrechen',
  },

  deleteConfirmationModal: {
    title: 'Veranstaltung löschen',
    description: 'Sind Sie sicher, dass Sie die Veranstaltung "{{eventName}}" löschen möchten? Diese Aktion ist irreversibel und alle zugehörigen Daten werden gelöscht.',
    confirm: 'Löschen',
    cancel: 'Abbrechen',
  },

  // Vorhandene Funktionen
  features: {
    aiAssistant: 'KI-Assistent',
    aiAssistantDesc: 'Erhalten Sie personalisierte Vorschläge und intelligente Hilfe.',
    taskManagement: 'Aufgabenverwaltung',
    taskManagementDesc: 'Organisieren und verfolgen Sie alle Ihre Veranstaltungsaufgaben.',
    budgetPlanning: 'Budgetplanung',
    budgetPlanningDesc: 'Verwalten Sie Ihr Budget mit detaillierten Tracking-Tools.',
    guestManagement: 'Gästeverwaltung',
    guestManagementDesc: 'Organisieren Sie Ihre Gästeliste und deren Antworten.',
    vendorCoordination: 'Dienstleister-Koordination',
    vendorCoordinationDesc: 'Finden und verwalten Sie Ihre Dienstleister einfach.',
    timelineTracking: 'Zeitplan-Verfolgung',
    timelineTrackingDesc: 'Visualisieren und planen Sie Ihren Veranstaltungszeitplan.',
    collaborativeTools: 'Kollaborationstools',
    collaborativeToolsDesc: 'Arbeiten Sie mit Ihrem Team und Ihren Liebsten zusammen.',
    documentSharing: 'Dokumentenfreigabe',
    documentSharingDesc: 'Teilen und organisieren Sie alle Ihre wichtigen Dokumente.',
    mobileSynchronization: 'Mobile Synchronisierung',
    mobileSynchronizationDesc: 'Greifen Sie überall mit Cloud-Synchronisierung auf Ihre Daten zu.',
    customTemplates: 'Benutzerdefinierte Vorlagen',
    customTemplatesDesc: 'Erstellen und verwenden Sie Vorlagen, die an Ihre Bedürfnisse angepasst sind.',
    realTimeNotifications: 'Echtzeit-Benachrichtigungen',
    realTimeNotificationsDesc: 'Bleiben Sie über wichtige Updates informiert.',
    advancedReporting: 'Erweiterte Berichte',
    advancedReportingDesc: 'Analysieren Sie Ihre Daten mit detaillierten Berichten.',
    duplicateDetection: 'Duplikat-Erkennung',
    duplicateDetectionDesc: 'Identifiziert ähnliche Veranstaltungen basierend auf Name, Typ und Datum.'
  },

  // Testseit-Übersetzungen
  testPage: {
    title: "🧪 Firebase-Funktionen Testseite",
    firebaseTest: {
      title: "Firebase-Funktionstest",
      description: "Testen Sie die Konnektivität mit Firebase-Funktionen, bevor Sie versuchen, das Konto zu löschen.",
      button: "Firebase-Funktion testen",
      result: "Ergebnis",
      userNotConnected: "❌ Benutzer nicht verbunden",
      testing: "🧪 Testen...",
      success: "✅ Test erfolgreich",
      error: "❌ Fehler",
      unknownError: "Unbekannter Fehler",
    },
    instructions: {
      title: "📋 Anweisungen",
      step1: "Klicken Sie oben auf \"Firebase-Funktion testen\"",
      step2: "Wenn der Test erfolgreich ist, gehen Sie zu Einstellungen → Konto",
      step3: "Versuchen Sie, Ihr Konto zu löschen",
      step4: "Die Backend-Funktion sollte ohne Passwortabfrage funktionieren",
    },
    messages: {
      eventCreated: "✅ Veranstaltung erfolgreich erstellt! ID: {{eventId}}",
      tasksGenerated: "🎯 {{count}} Aufgaben automatisch generiert!",
      noTasksFound: "⚠️ Keine Aufgaben gefunden. Verwenden Sie die Debug-Schaltfläche, um manuell zu generieren.",
      errorLoadingTasks: "❌ Fehler beim Laden der Aufgaben",
      errorCreatingEvent: "❌ Fehler",
      waitingForTasks: "🔄 Warte 3 Sekunden vor dem Laden der Aufgaben...",
      loadingTasks: "🔍 Lade Aufgaben für Veranstaltung:",
      tasksReloaded: "🔄 Neu geladen: {{count}} Aufgaben gefunden",
      errorReloadingTasks: "❌ Fehler beim Neuladen der Aufgaben",
      debuggingGeneration: "🔧 Debugge Aufgabenerstellung...",
      manualGenerationComplete: "✅ Manuelle Generierung abgeschlossen",
      debugError: "❌ Debug-Fehler",
      testingExistingEvent: "🧪 Testen mit vorhandener Veranstaltung...",
      eventNotFound: "❌ Veranstaltung nicht gefunden",
      eventFound: "📋 Veranstaltung gefunden",
      eventDate: "📅 Datum",
      eventCountry: "🌍 Land",
      notSpecified: "Nicht angegeben",
      existingTasks: "📊 Vorhandene Aufgaben",
      generatingTasks: "🔧 Generiere Aufgaben (falls erforderlich)...",
      generationComplete: "✅ Generierung abgeschlossen",
      newTasks: "📊 Neue Aufgaben",
      testError: "❌ Testfehler",
      generatingForAllEvents: "🔄 Generiere Aufgaben für alle vorhandenen Veranstaltungen...",
      noEventsFound: "📋 Keine Veranstaltungen gefunden",
      eventsFound: "📊 {{count}} Veranstaltung(en) gefunden",
      processingEvent: "🔧 Verarbeite",
      generatingTasksFor: "🎯 Generiere Aufgaben für",
      tasksGeneratedFor: "✅ {{count}} Aufgaben generiert für",
      eventAlreadyHasTasks: "✅ {{name}} hat bereits {{count}} Aufgaben",
      errorProcessingEvent: "❌ Fehler für",
      processingComplete: "🎉 Verarbeitung abgeschlossen: {{processed}} Veranstaltungen verarbeitet, {{generated}} neue Aufgaben generiert",
      globalError: "❌ Globaler Fehler",
    },
    eventTypes: {
      wedding: "Hochzeit",
      birthday: "Geburtstag",
      engagement: "Verlobung",
      babyShower: "Babyparty",
      baptism: "Taufe",
      other: "Sonstiges",
    },
  },

  eventForm: {
    title: "Veranstaltungsdetails",
    name: "Veranstaltungsname",
    description: "Beschreibung",
    date: "Datum",
    time: "Zeit",
    location: "Ort",
    type: "Veranstaltungstyp",
    guests: "Geschätzte Gästeanzahl",
    budget: "Geschätztes Budget",
    notes: "Notizen",
    submit: "Veranstaltung erstellen",
    cancel: "Abbrechen",
    edit: "Bearbeiten",
    delete: "Löschen",
    partner1: "Partner 1",
    partner2: "Partner 2",
    firstName: "Vorname",
    lastName: "Nachname"
  },
  
  messages: {
    createSuccess: "Veranstaltung erfolgreich erstellt",
    updateSuccess: "Veranstaltung erfolgreich aktualisiert",
    deleteSuccess: "Veranstaltung erfolgreich gelöscht",
    deleteConfirm: "Sind Sie sicher, dass Sie diese Veranstaltung löschen möchten?",
    error: "Ein Fehler ist aufgetreten",
    eventUpdated: "Veranstaltung erfolgreich aktualisiert",
    eventDeleted: "Veranstaltung erfolgreich gelöscht",
    updateError: "Fehler beim Aktualisieren",
    deleteError: "Fehler beim Löschen",
    invalidDate: "Ungültiges Datum"
  },
  
  eventActions: {
    view: "Anzeigen",
    edit: "Bearbeiten",
    delete: "Löschen",
    duplicate: "Duplizieren",
    share: "Teilen",
    setDefault: "Als Standard festlegen"
  },
  
  validation: {
    accountHealth: 'Kontostatus',
    problemsDetected: 'Probleme mit Ihren Veranstaltungen erkannt',
    suggestions: 'Vorschläge',
    cannotCreate: 'Neue Veranstaltung kann nicht erstellt werden',
    cannotDelete: 'Veranstaltung kann nicht gelöscht werden',
    limitReached: 'Veranstaltungslimit erreicht',
    multipleEventsNotAllowed: 'Ihr Abonnement erlaubt keine mehreren Veranstaltungen',
    cannotDeleteDefault: 'Standardveranstaltung kann nicht gelöscht werden',
    cannotDeleteLast: 'Letzte Veranstaltung kann nicht gelöscht werden',
    duplicateFound: 'Eine ähnliche Veranstaltung existiert bereits',
    continueAnyway: 'Möchten Sie fortfahren?',
    upgradeRequired: 'Upgrade erforderlich',
    noEventsFound: 'Keine Veranstaltungen gefunden',
    noDefaultEvent: 'Keine Standardveranstaltung definiert',
    multipleDefaultEvents: 'Mehrere Veranstaltungen als "Standard" definiert',
    eventsWithoutName: 'Veranstaltung(en) ohne Namen',
    healthyAccount: 'Konto in gutem Zustand',
    setAnotherAsDefault: 'Legen Sie zuerst eine andere Veranstaltung als Standard fest',
    createBeforeDelete: 'Erstellen Sie eine neue Veranstaltung, bevor Sie diese löschen'
  },
  
  faq: {
    convertEvent: {
      question: "Wie konvertiere ich eine Veranstaltung in einen bestimmten Typ?",
      answer: "Sie können den Veranstaltungstyp in den Einstellungen ändern. Dadurch werden die verfügbaren Funktionen automatisch angepasst."
    }
  }
};
